import React from 'react'
import Raven from 'raven-js'

const handleReportError = (error: string) => {
    Raven.captureException(error, {
        tags: {
            web: 'h5-hezi.xunlei.com'
        }
    })
}

type TProps = {
    children: React.ReactNode
}
type TState = {
    hasError: boolean,
    errMsg: string
}

class ErrorBoundary extends React.PureComponent<TProps, TState> {
    constructor(props: TProps) {
        super(props)
        this.state = {
            hasError: false,
            errMsg: ''
        }
    }

    static getDerivedStateFromError() {
        return { hasError: true }
    }

    componentDidCatch(error: unknown, errorInfo: unknown) {
        // @ts-ignore
        if (process.env.NODE_ENV === 'production') handleReportError(error)

        this.setState({
            errMsg: String(error)
        })
        console.warn(error, errorInfo)
    }

    render() {
        return this.state.hasError ? (
            <div>
                <div className="sub-title" />
                <div>
                    {
                        this.state.errMsg
                    }
                </div>
            </div>
        ) : this.props.children
    }
}

export default ErrorBoundary
